import React, { Component } from 'react'
import Parser from 'html-react-parser'
import { ChevronDownIcon } from './SVGIcons'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openIndex: 0 // по умолчанию открыт первый элемент (индекс 0)
    }
  }

  toggleAccordion = (index) => {
    this.setState(prevState => ({
      openIndex: prevState.openIndex === index ? -1 : index
    }))
  }

  render() {
    const data = this.props?.data || {}
    const faq = data?.faq || {}
    const cards = faq?.cards || []

    const { openIndex } = this.state

    return (
      <div className='mt-[80px] xl:mt-[100px]'>
        <div className='container'>

          <div className='text-title text-ptblack uppercase tracking-tight leading-none'>{Parser(faq?.title || '')}</div>
          <div className='text-base text-ptgray max-w-[672px] leading-none mt-[10px]'>
            {Parser(faq?.text || '')}
          </div>

          <div className='pt-[10px] mt-[40px]'>
            {cards.map((elm, index) => (
              <div 
                key={index}
                className='mt-[10px] bg-[#F6F7F8] rounded-[15px] p-[20px] cursor-pointer'
                onClick={() => this.toggleAccordion(index)}
              >
                <div className='flex items-center justify-between gap-[20px] text-[#032432] text-[16px] xl:text-cardTitle uppercase'>
                  <div>{elm.q}</div>
                  <div className={`w-[30px] h-[30px] xl:w-[38px] xl:h-[38px] flex-none rounded-[14px] flex items-center justify-center  transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180 bg-white text-[#001553]' : 'bg-[#001553] text-white'
                  }`}>
                    <ChevronDownIcon width={12} height={6} stroke="currentColor" />
                  </div>
                </div>
                
                {/* Анимация для плавного появления/скрытия */}
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-[500px] opacity-100 mt-[10px]' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className='text-[12px] xl:text-base text-black/60 tracking-[-0.02em] page_content'>
                    {Parser(elm.a)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default App